// src/pages/Anim01Page.js

 // 🛑 Import useEffect
 // 🛑 Import useNavigate
import Ballpit from './Ballpit';

const Anim01Page = () => {
    

    return (
        <div style={{
            backgroundColor:'#000000',
            position: 'relative',
            overflow: 'hidden',
            minHeight: '100vh',
            maxHeight: '100vh',
            width: '100%'
        }}>
            
            {/* The visual "Back to Home" Link (for mouse users) */}
            
            
            {/* Ballpit Simulation */}
            <Ballpit
                count={200}
                gravity={0.1}
                friction={0.9975}
                wallBounce={0.95}
                followCursor={false}
                colors={["#ffffff", "#000000", "#0000ff"]}
            />
        </div>
    );
};

export default Anim01Page;